// Import states.
import {
	BroadLineOfBusinessState,
} from './BroadLineOfBusinessState';
import {
	ClaimState,
	getInitialState as getInitialClaimState
} from './ClaimState';
import {
	EndorsementState,
} from './EndorsementState';
import {
	PolicyState,
} from './PolicyState';
import {
	PossibleProducerAgentsState,
} from './PossibleProducerAgentsState';
import {
	NewBusinessApplicationPreliminaryState,
	getInitialState as getInitialNewBusinessApplicationPreliminaryState,
} from './NewBusinessApplicationPreliminaryState';
import {
	ProducerSignupState,
	getInitialState as getInitialProducerSignupState
} from './ProducerSignupState';
import {
	AdministratorState,
	getInitialAdministratorState
} from './StatesBarrel';
// Import enumerations
import {
	AppMode
} from '@app/enumerations';
// Import api models.
import {
	AppLink,
	DisqualifiersText,
	PossibleCorrespondenceRecvdOrSent,
	PossibleCorrespondenceSubject,
	PossibleCorrespondenceType,
	PossibleCorrespondenceWho,
	PossibleDocCategory,
	PossibleProducerAgency,
	PossibleState,
	ValidNewBusinessInceptionDateBoundaries,
} from '@app/models/api';
// Import app models.
import {
	AppNotification,
	ProcessTarget,
} from '@app/models/app';

interface AppState {
	administrator: AdministratorState;
	appMode: Map<AppMode, boolean>;
	areMainNavigationLinksLoaded: boolean;
	arePossibleCorrespondenceRecvdOrSentLoaded: boolean;
	arePossibleCorrespondenceSubjectsLoaded: boolean;
	arePossibleCorrespondenceTypesLoaded: boolean;
	arePossibleCorrespondenceWhoLoaded: boolean;
	arePossibleDocCategoriesLoaded: boolean;
	arePossibleProducerAgenciesLoaded: boolean;
	arePossibleStatesLoaded: boolean;
	areValidNewBusinessInceptionDateBoundariesLoaded: boolean;
	claim: ClaimState;
	disqualifiersText: DisqualifiersText | undefined;
	endorsements: { [endorsementId: string]: EndorsementState };
	mainNavigationLinks: AppLink[];
	notifications: AppNotification[];
	policies: { [policyId: number]: PolicyState };
	possibleBroadLinesOfBusiness: { [broadLineOfBusinessCode: string]: BroadLineOfBusinessState }
	possibleCorrespondenceRecvdOrSent: PossibleCorrespondenceRecvdOrSent[];
	possibleCorrespondenceSubjects: PossibleCorrespondenceSubject[];
	possibleCorrespondenceTypes: PossibleCorrespondenceType[];
	possibleCorrespondenceWho: PossibleCorrespondenceWho[];
	possibleDocCategories: PossibleDocCategory[];
	possibleProducerAgencies: PossibleProducerAgency[];
	possibleProducerAgents: { [producerAgencyId: string]: PossibleProducerAgentsState }
	possibleStates: PossibleState[];
	newBusinessApplicationPreliminary: NewBusinessApplicationPreliminaryState
	processTargets: { [id: string]: ProcessTarget };
	producerSignup: ProducerSignupState;
	validNewBusinessInceptionDateBoundaries: ValidNewBusinessInceptionDateBoundaries | undefined;	
};

const getInitialState = (): AppState => {
	return {
		administrator: getInitialAdministratorState(),
		appMode: new Map<AppMode, boolean>(),
		areMainNavigationLinksLoaded: false,
		arePossibleCorrespondenceRecvdOrSentLoaded: false,
		arePossibleCorrespondenceSubjectsLoaded: false,
		arePossibleCorrespondenceTypesLoaded: false,
		arePossibleCorrespondenceWhoLoaded: false,
		arePossibleDocCategoriesLoaded: false,
		arePossibleProducerAgenciesLoaded: false,
		arePossibleStatesLoaded: false,
		areValidNewBusinessInceptionDateBoundariesLoaded: false,
		claim: getInitialClaimState(),
		disqualifiersText: undefined,
		endorsements: {},
		mainNavigationLinks: [],
		notifications: [],
		policies: {},
		possibleBroadLinesOfBusiness: {},
		possibleCorrespondenceRecvdOrSent: [],
		possibleCorrespondenceSubjects: [],
		possibleCorrespondenceTypes: [],
		possibleCorrespondenceWho: [],
		possibleDocCategories: [],
		possibleProducerAgencies: [],
		possibleProducerAgents: {},
		possibleStates: [],
		newBusinessApplicationPreliminary: getInitialNewBusinessApplicationPreliminaryState(),
		processTargets: {},
		producerSignup: getInitialProducerSignupState(),
		validNewBusinessInceptionDateBoundaries: undefined,
	};
}

export { getInitialState, AppState };